module.exports = __webpack_public_path__ + "img/allianz_logo.a6e91fb5.png";